import "pixi";
import "phaser";

import AudioEngine from "../audio_engine"
import * as cursor from "../cursor";
import * as i18n from "../i18n";

export default class BackButton extends Phaser.Group {
    game: Phaser.Game;
    back_triangle: Phaser.Sprite;
    back_button: i18n.Text;
    triTween: Phaser.Tween | null;
    callback: () => void;

    constructor(game: Phaser.Game, callback: () => void, parent?: Phaser.Group) {
        super(game, parent);
        this.game = game;
        this.callback = callback;

        this.back_triangle = this.game.add.sprite(40, 44, "play");
        this.back_triangle.angle = 180;
        this.back_triangle.anchor.setTo(0.5, 0.5);

        this.back_button = i18n.label(this.game, 64, 44, i18n._("BACK"), "font-small", 24);
        this.back_button.anchor.setTo(0, 0.5);

        this.addMultiple([this.back_triangle, this.back_button]);
    }

    enable() {
        this.back_button.inputEnabled = true;
        cursor.instance().addClickable(this.back_button.input);
        this.back_button.events.onInputOver.add(this.onHover, this);
        this.back_button.events.onInputOut.add(this.outHover, this);
        this.back_button.events.onInputDown.add(() => {
            AudioEngine.get().play("button_click");
            this.callback();
          });

        this.back_triangle.inputEnabled = true;
        cursor.instance().addClickable(this.back_triangle.input);
        this.back_triangle.events.onInputOver.add(this.onHover, this);
        this.back_triangle.events.onInputOut.add(this.outHover, this);
        this.back_triangle.events.onInputDown.add(() => {
            AudioEngine.get().play("button_click");
            this.callback();
        });
    }

    onHover(item: Phaser.Sprite) {
        AudioEngine.get().play("button_hover");
        if (this.triTween != null) {
            this.triTween.stop();
        }
        this.triTween = this.game.add.tween(this.back_triangle).to( { x: 30 }, 60, "Linear", true);
    }

    outHover(item: Phaser.Sprite) {
        if (this.triTween != null) {
            this.triTween.stop();
        }
        this.triTween = this.game.add.tween(this.back_triangle).to( { x: 40 }, 60, "Linear", true);
    }
}



// WEBPACK FOOTER //
// ./src/ui/back.ts